import React from 'react';
import { styled } from '@compiled/react';
import Lozenge from '@atlaskit/lozenge';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import messages from './messages.tsx';

export type Props = {
	intl: IntlShape;
};

function Private(props: Props) {
	const {
		intl: { formatMessage },
	} = props;

	const tooltipContent = <TooltipContent>{formatMessage(messages.tooltip)}</TooltipContent>;

	if (isVisualRefreshEnabled()) {
		return (
			<Flex xcss={flexContainerStyles}>
				<Tooltip content={tooltipContent}>
					<Lozenge isBold>{formatMessage(messages.lozenge)}</Lozenge>
				</Tooltip>
			</Flex>
		);
	}

	return (
		<Box xcss={containerStyles}>
			<Tooltip content={tooltipContent}>
				<Lozenge isBold>{formatMessage(messages.lozenge)}</Lozenge>
			</Tooltip>
		</Box>
	);
}

export default injectIntl(Private);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TooltipContent = styled.div({
	textAlign: 'center',
	maxWidth: '152px',
});

const containerStyles = xcss({
	paddingTop: 'space.150',
	paddingBottom: 'space.150',
});

const flexContainerStyles = xcss({
	alignItems: 'center',
	height: token('space.500'),
});
